import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { BehaviorSubject, debounceTime, filter, map, Observable, of, Subject, takeUntil } from 'rxjs';
import { CompanyAccess, MenuItem, Toast, toastFactory, UserProfile } from '../../models';
import { ModalLoaderComponent } from '../../modules/shared/modal-loader/modal-loader.component';
import { environment } from '../../../environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import * as fromStore from '../../store';

import { Router } from '@angular/router';
import { ENV_CONFIG, EnvironmentConfig } from '../../../environments/environment.model';
import { FittingsService } from '../../services/fittings.service';
import { Guid } from '../../util/guid';
import { Logger } from 'src/app/util/logger';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  profile$: Observable<UserProfile | null> = of();
  menuItems$: Observable<MenuItem[]> = of([])
  url$: Observable<string> = of('');
  companyAccess$?: Observable<CompanyAccess | undefined>;
  unsubscribe$ = new Subject();
  toasts$: Observable<Toast[]> = of([]);
  errors$: Observable<({ name: string; message: any; } | { name: string; mesage: string | null; }[])[]> = of([]);
  errorTotalMessage$: Observable<string> = of('');
  cachedItems$: Observable<{ key: string; value: string | null; }[]> = of([]);
  version: string = '';
  isHandheld$: Observable<boolean> = of();
  currentRoute$: Observable<string> = of();
  sidebarSubject$ = new Subject<boolean>();

  constructor(
    private store: Store<fromStore.State>,
    private modalService: NgbModal,
    private router: Router,
    @Inject(ENV_CONFIG) public config: EnvironmentConfig,
    private breakpointObserver: BreakpointObserver
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  ngOnInit(): void {
    this.version = this.config.appVersion + (['dev', 'uat'].includes(this.config.environmentName.toLowerCase()) ? `-${this.config.environmentName}` : '');
    // this.store.dispatch(fromStore.actions.USERPROFILE.loadUserProfile())
    this.profile$ = this.store.select(fromStore.selectors.USERPROFILE.selectUserProfile);
    this.menuItems$ = this.store.select(fromStore.selectors.USERPROFILE.selectMenu);
    this.url$ = this.store.select(fromStore.selectors.ROUTER.selectUrl);
    this.companyAccess$ = this.store.select(fromStore.selectors.USERPROFILE.selectCompanyAccess);
    this.errors$ = this.store.select(fromStore.selectors.ERRORS.selectErrorMessages);
    this.toasts$ = this.store.select(fromStore.selectors.MESSAGES.selectToasts);
    this.sidebarSubject$.pipe(debounceTime(200));

    this.errorTotalMessage$ = this.errors$.pipe(map(errors => `Click to see errors :: ${errors.length} errors have occurred`));

    const showLoader$ = this.store.select(fromStore.selectors.GLOBAL.selectShowModalLoader)

    this.currentRoute$ = this.store.select(fromStore.selectors.ROUTER.selectUrl);

    let modal: any = null;
    showLoader$.pipe(takeUntil(this.unsubscribe$))
      .subscribe(s => {
        if (!!s) modal = this.modalService.open(ModalLoaderComponent, { ...environment.modalOptions })
        if (!s && !!modal) modal.close();
      });

    this.isHandheld$ = this.breakpointObserver.observe([
      Breakpoints.XSmall, // < 600px
      Breakpoints.TabletPortrait   // < 840px
    ]).pipe(map(result => result.matches));
  }

  search(q: any): void {
    const query = q + '%';
    if (query.length > 2) this.store.dispatch(fromStore.actions.SEARCH.setSearchQuery({ q: query }));
    this.router.navigate(['search']);
  }

  showToastForRemoveCacheKey(key: string): void {
    this.store.dispatch(fromStore.actions.MESSAGES.addToast({
      toast: toastFactory({
        class: 'info',
        icon: 'fa-info-circle',
        message: `CacheKey "${key}" removed`,
        title: 'Local Cache',
        id: Guid.newGuid()
      })
    }));
  }

  logout(): void {
    this.store.dispatch(fromStore.actions.USERPROFILE.logout());
  }

  removeToast(toast: Toast): void {
    this.store.dispatch(fromStore.actions.MESSAGES.removeToast({ id: toast.id }));
  }

  onToggleSidebar(state: boolean): void {
    this.sidebarSubject$.next(state);
  }

}
